import { render, staticRenderFns } from "./replacepaper.vue?vue&type=template&id=40d200aa&scoped=true"
import script from "./replacepaper.vue?vue&type=script&lang=js"
export * from "./replacepaper.vue?vue&type=script&lang=js"
import style0 from "./replacepaper.vue?vue&type=style&index=0&id=40d200aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d200aa",
  null
  
)

export default component.exports